<ion-header>
    <ion-toolbar>
      <ion-title>Participant</ion-title>
      <ion-buttons end>
        <button ion-button color="primary">
          {{'GLOBAL_SAVE' | translate}}
        </button>
      </ion-buttons>
    </ion-toolbar>
  
    <ion-toolbar no-border-top class="navbar">
      <ion-segment [(ngModel)]="selectedSegment">
        <ion-segment-button value="participant">
            {{ 'NEARBY_COMPETITOR' | translate }}
        </ion-segment-button>
        <ion-segment-button value="contact">
            {{ 'EVENT_DETAILS_TAB_CONTACT' | translate }}
        </ion-segment-button>
      </ion-segment>
    </ion-toolbar>
  
  </ion-header>

  <ion-content>
    <div [ngSwitch]="selectedSegment">
        <ion-list *ngSwitchCase="'participant'" style="margin-top: -3em !important">
            <div class="position-relative">
                <ion-slides centeredSlides="true">
                  <ion-slide>
                    <image-container height="100px" src="/assets/imgs/profileBackgrounds/concrete.jpg"> </image-container>
                  </ion-slide>
                </ion-slides>
            </div>
            
              <ion-card no-margin overflow-all style="position: relative; z-index: 100;">
                <ion-item no-lines>
                  <ion-row>
                    <ion-col col-auto no-padding>
                      <span
                        class="profile-image-upload user-image-xl offset-top" circle >
                        <div class="vertical-center-outer">
                          <div class="vertical-center-inner">
                            <ion-icon color="white" name="camera"></ion-icon>
                          </div>
                        </div>
                      </span>
                    </ion-col>
                  </ion-row>
                </ion-item>
              </ion-card>

              <ion-row>
                  <ion-col>
                    <ion-select [(ngModel)]="selectedParticipant" multiple="false">
                        <ion-option value="team-select">{{ 'TEAM' | translate }}</ion-option>
                        <ion-option value="athlete-select">{{ 'ATHLETE' | translate }}</ion-option>
                      </ion-select>
                  </ion-col>
              </ion-row>
              
            <div *ngIf="selectedParticipant == 'team-select'">
                <ion-list-header text-left>
                    Name
                </ion-list-header>
                <ion-item class="part-name">
                    <ion-label>{{ 'PRIVATEPROFILE_TEAM_NAME' | translate }}</ion-label>
                    <ion-input [(ngModel)]="team.name"></ion-input>
                </ion-item>
            </div>
            <div *ngIf="selectedParticipant == 'athlete-select'">
                <ion-list-header text-left>
                    Name
                </ion-list-header>
                <ion-item class="part-name">
                    <ion-label>{{ 'PRIVATEPROFILE_FIRST_NAME' | translate }}</ion-label>
                    <ion-input type="tel"></ion-input>
                </ion-item>
                <ion-item class="part-surname">
                    <ion-label>{{ 'PRIVATEPROFILE_LAST_NAME' | translate }}</ion-label>
                    <ion-input type="url"></ion-input>
                </ion-item>
            </div>
            
        </ion-list>
        <ion-list *ngSwitchCase="'contact'" style="margin-top: -2em !important">
            <ion-list>
                <ion-list-header text-left>
                  {{'EVENT_LOCATION_TITLE' | translate}}
                </ion-list-header>
                <ion-item>
                    <ion-label>{{'EVENT_STREET' | translate}}</ion-label>
                    <ion-input  type="text"></ion-input>
                </ion-item>
            
                <ion-item>
                    <ion-label>{{'EVENT_HOUSE_NUMBER' | translate}}</ion-label>
                    <ion-input  type="text"></ion-input>
                </ion-item>
            
                <ion-item>
                    <ion-label>{{'EVENT_ZIP' | translate}}</ion-label>
                    <ion-input  type="number" maxlength="5" pattern="[0-9]*"></ion-input>
                </ion-item>
            
                <ion-item>
                    <ion-label>{{'EVENT_PLACE' | translate}}</ion-label>
                    <ion-input  type="text"></ion-input>
                </ion-item>
                <ion-item class="search-field-nobg">
                    <ion-label>{{'EVENT_COUNTRY' | translate}}</ion-label>
                    <ion-select  cancelText="{{'GLOBAL_CANCEL' | translate}}" okText="{{'GLOBAL_OK' | translate}}">
                        <ion-option>Germany</ion-option>
                    </ion-select>
                </ion-item>

                <ion-list>
                    <ion-list-header text-left>
                      {{'EVENT_KONTAKT_TITLE' | translate}}
                    </ion-list-header>

                    <ion-item>
                        <ion-label>Phone</ion-label>
                        <ion-input  type="url"></ion-input>
                    </ion-item>

                    <ion-item>
                        <ion-label>{{'EVENT_EMAIL' | translate}}</ion-label>
                        <ion-input  type="tel"></ion-input>
                    </ion-item>
                    
                    <ion-item>
                        <ion-label>Url</ion-label>
                        <ion-input type="text"></ion-input>
                    </ion-item>
                    
                </ion-list>

            </ion-list>
        </ion-list>
    </div>
  </ion-content>